"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  exceptions: [{
    gender: 'androgynous',
    test: ['борух'],
    mods: ['.', '.', '.', '.', '.'],
    tags: ['first_word']
  }],
  suffixes: [{
    gender: 'male',
    test: ['мич', 'ьич', 'кич'],
    mods: ['а', 'у', 'а', 'ом', 'е']
  }, {
    gender: 'male',
    test: ['ич'],
    mods: ['а', 'у', 'а', 'ем', 'е']
  }, {
    gender: 'female',
    test: ['на'],
    mods: ['-ы', '-е', '-у', '-ой', '-е']
  }]
};